import { FC } from "react";

import { AssessmentSummaryReport } from "./AssessmentSummaryReport";
import { SectionEnrollmentReport } from "./SectionEnrollmentReport";
import { StudentLearningOutcomesReport } from "./StudentLearningOutcomesReport";
import { StudentSectionScoresReport } from "./StudentSectionScoresReport";
import { SystemChecksReport } from "./SystemChecksReport";

export const ReportsView: FC = () => {
  return (
    <div className="reports-view h-full space-y-8 overflow-y-auto pb-4">
      <SectionEnrollmentReport />

      <AssessmentSummaryReport />

      <StudentLearningOutcomesReport />

      <StudentSectionScoresReport />

      <SystemChecksReport />
    </div>
  );
};
